var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("供应系统")]),
              _c("el-breadcrumb-item", [_vm._v("供应点管理")]),
              _c("el-breadcrumb-item", [_vm._v("领货管理")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "hx-form-container box-shadow" },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.listParams, "label-width": "100px" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "领货日期：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                placeholder: "请选择领货日期",
                                size: "small",
                              },
                              model: {
                                value: _vm.listParams.date,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listParams, "date", $$v)
                                },
                                expression: "listParams.date",
                              },
                            },
                            _vm._l(_vm.dateList, function (item) {
                              return _c("el-option", {
                                key: item.dateId,
                                attrs: {
                                  value: item.dateId,
                                  label: _vm._f("formatDate")(item.date),
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单编号", prop: "orderNo" } },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "small",
                              placeholder: "请输入订单编号",
                            },
                            model: {
                              value: _vm.listParams.orderNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.listParams, "orderNo", $$v)
                              },
                              expression: "listParams.orderNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "手机号码：", prop: "mobile" } },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "small",
                              placeholder: "请输入手机号码",
                            },
                            model: {
                              value: _vm.listParams.mobile,
                              callback: function ($$v) {
                                _vm.$set(_vm.listParams, "mobile", $$v)
                              },
                              expression: "listParams.mobile",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.loadTableData("init")
                                },
                              },
                            },
                            [_vm._v(" 查询 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: { "page-info": _vm.pager, loading: _vm.tableLoading },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c(
              "div",
              {
                staticClass: "wrap-table-info-display",
                staticStyle: { height: "32px" },
              },
              [
                _c("span", { staticClass: "table-info-display" }, [
                  _c("span", [_vm._v("总条数：")]),
                  _c("span", { staticClass: "alert-text ft16" }, [
                    _vm._v(_vm._s(_vm.pager.total)),
                  ]),
                ]),
              ]
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                slot: "content",
                data: _vm.tableData,
                "max-height": "800",
                border: "",
              },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", width: "60", label: "序号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              (_vm.pager.pageIndex > 1
                                ? (_vm.pager.pageIndex - 1) * _vm.pager.pageSize
                                : 0) +
                                scope.$index +
                                1
                            ),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "mobile", align: "center", label: "手机号" },
              }),
              _c("el-table-column", {
                attrs: { prop: "date", align: "center", label: "供应日期" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm._f("formatDate")(scope.row.date))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "areaNo", align: "center", label: "位置号" },
              }),
              _c("el-table-column", {
                attrs: { prop: "orderNo", align: "center", label: "订单编号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.orderNo
                          ? _c("div", [
                              scope.row.orderNo.length > 10
                                ? _c(
                                    "div",
                                    [
                                      _c("el-popover", {
                                        ref: "popover1",
                                        attrs: {
                                          placement: "top-start",
                                          width: "200",
                                          trigger: "hover",
                                          content: scope.row.orderNo,
                                        },
                                      }),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "popover",
                                              rawName: "v-popover:popover1",
                                              arg: "popover1",
                                            },
                                          ],
                                          staticStyle: { color: "#606266" },
                                          attrs: { type: "text" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("formatLimitLength")(
                                                  scope.row.orderNo
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _c("div", [
                                    _vm._v(
                                      " " + _vm._s(scope.row.orderNo) + " "
                                    ),
                                  ]),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodTitle",
                  align: "center",
                  label: "菜品名称",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "specTitle", align: "center", label: "规格" },
              }),
              _c("el-table-column", {
                attrs: { prop: "quantity", align: "center", label: "数量" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "hx-to-create-template",
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.resetDialogForm,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "dialogForm",
                  attrs: {
                    model: _vm.itemParams,
                    rules: _vm.checkItemParams,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "供应点名称 ：",
                        prop: "supplyCentreName",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          placeholder: "请输入供应点名称",
                        },
                        model: {
                          value: _vm.itemParams.supplyCentreName,
                          callback: function ($$v) {
                            _vm.$set(_vm.itemParams, "supplyCentreName", $$v)
                          },
                          expression: "itemParams.supplyCentreName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "供应点地址 ：",
                        prop: "supplyCentreAddr",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          placeholder: "请输入供应点地址",
                        },
                        model: {
                          value: _vm.itemParams.supplyCentreAddr,
                          callback: function ($$v) {
                            _vm.$set(_vm.itemParams, "supplyCentreAddr", $$v)
                          },
                          expression: "itemParams.supplyCentreAddr",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.saveSupplyCentre },
                        },
                        [_vm._v(" 保 存 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              _vm.dialogVisible = false
                            },
                          },
                        },
                        [_vm._v(" 取 消 ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }